import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Neighbors from "@/pages/Neighbors";

export const Route = createFileRoute("/_public/neighbors")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Neighbor Map \u2014 Real Installs Near You | Modern Fence Install", "See real Modern Fence Install projects town by town across CT, NY, MA, RI, VT, NH, and PA. Curated, homeowner-approved snapshots of recent installs.", "/neighbors", false),
  component: Neighbors,
});
